import { createSlice } from '@reduxjs/toolkit';
import {
  addGeneration,
  fetchGenerations,
  fetchGenerationsByModel,
  removeGeneration,
  editGeneration,
} from '../actions/vehicleGenerations-actions';
import { Status } from '../../helpers/consts/status';

const initialState = {
  isLoading: false,
  generations: [],
  filteredGenerations: [],
  count: 0,
};

const generationsSlice = createSlice({
  name: 'vehicleGenerations',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchGenerations.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchGenerations.fulfilled, (state, action) => {
        const generations = action.payload;
        state.generations = generations;
        state.isLoading = false;
       // state.status = Status.COMPLETED;
      })
      .addCase(fetchGenerations.rejected, (state, action) => {})
      .addCase(fetchGenerationsByModel.fulfilled, (state, action) => {
        const generations = action.payload;
        state.filteredGenerations = generations;
        state.isLoading = false;
       // state.status = Status.COMPLETED;
      })
      .addCase(addGeneration.fulfilled, (state, action) => {
        const newGeneration = action.payload;
        state.generations.push(newGeneration);
      })
      .addCase(editGeneration.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.generations.findIndex(
          (generation) => generation.id === data.id
        );
        if (~index) {
          state.generations[index] = data;
        }
      })
      .addCase(removeGeneration.fulfilled, (state, action) => {
        const generationId = action.payload;
        console.log(action.payload);

        state.generations = state.generations.filter(
          (generation) => generation.id !== generationId
        );
      });
  },
});

export const generationsActions = generationsSlice.actions;

export default generationsSlice;
